import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}
const _hoisted_2 = { class: "bg-white space-y-6 rounded-lg shadow-lg p-6 max-w-md w-full" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_4 = { class: "font-medium text-red-800" }
const _hoisted_5 = { class: "text-sm text-red-700" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700"
}

import { computed } from "vue";
import { useRouter } from "vue-router";
import {
  taskDependencies,
  taskDependencyWarnings,
} from "@/services/v2/tasks";


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskDependencyWarningModal',
  setup(__props) {

const router = useRouter();

const warningItems = computed(() => taskDependencyWarnings.value);

const handleProceed = () => {
  taskDependencies.value = false;
};

const handleClose = () => {
  taskDependencies.value = false;
  router.back();
};

return (_ctx: any,_cache: any) => {
  return (_unref(taskDependencies))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-xl font-semibold mb-2" }, "Unresolved Dependencies"),
            _createElementVNode("p", { class: "text-gray-700" }, " This task depends on unfinished work. Proceeding may result in data inconsistency. ")
          ], -1)),
          (warningItems.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warningItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `${item.key || item.title}-${item.reason}`,
                    class: "rounded border border-red-200 bg-red-50 px-3 py-2"
                  }, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1),
                    _createElementVNode("p", _hoisted_5, [
                      _createTextVNode(_toDisplayString(item.reason) + " ", 1),
                      (item.status)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(" + _toDisplayString(item.status) + ")", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, " The server reported unresolved dependencies but did not include dependency details. ")),
          _createElementVNode("div", { class: "flex gap-2 items-center" }, [
            _createElementVNode("button", {
              class: "bg-[#dc2626] hover:bg-[#dc2626]/80 text-white transition-all px-4 py-1 rounded",
              onClick: handleProceed
            }, " Proceed anyway "),
            _createElementVNode("button", {
              class: "bg-primary hover:bg-primary/80 transition-all text-white px-4 py-1 rounded",
              onClick: handleClose
            }, " Close ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})